import { useField, useFormikContext } from 'formik';
import React from 'react';

import styled from '@emotion/styled';

import StarFillIcon from '../Icons/StarFillIcon';
import StarOutlineICon from '../Icons/StarOutlineICon';
import { FieldErrorInfo } from './FormField';

interface CustomStarsRadioFieldProps {
  children: React.ReactNode;
  name: string;
  className?: string;
}

export const CustomStarsRadioField: React.FC<CustomStarsRadioFieldProps> = ({
  children,
  name,
  className,
}) => {
  const { errors, touched, values } = useFormikContext<any>();

  return (
    <RadioGroup>
      <FlexContent>
        {/* {React.Children.map(children, (child: any) => {
          return React.cloneElement(child, {
            ...child.props,
          });
        })} */}

        {Array.from({ length: 5 }, (_, i) =>
          // <CustomStars
          //   key={i}
          //   name='accountCreatorRole'
          //   value={(i + 1).toString()}
          // />

          React.Children.map(children, (child: any) => {
            return React.cloneElement(child, {
              ...child.props,
              value: (i + 1).toString(),
              key: i,
              isActive: i + 1 <= parseInt(values[name] || '0'),
            });
          }),
        )}
      </FlexContent>

      {errors[name] && touched[name] ? (
        <CustomFieldErrorInfo className={className}>
          {(errors as any)[name].capitalize()}
        </CustomFieldErrorInfo>
      ) : null}
    </RadioGroup>
  );
};

export interface CustomStarProps {
  label?: any;
  id?: string;
  name: string;
  children?: any;
  className?: string;
  value?: string;
  isActive?: boolean;
}

export const CustomStars: React.FC<CustomStarProps> = ({
  children,
  className,
  isActive,
  ...props
}) => {
  const [field] = useField({ ...props, type: 'radio' });

  return (
    <RadioWrapper className={className}>
      <label>
        <input type='radio' {...field} {...props} />
        <RadioItemDiv>
          {isActive ? (
            <RadioItemActiveIcon>
              <StarFillIcon />
            </RadioItemActiveIcon>
          ) : (
            <RadioItemInactiveIcon>
              <StarOutlineICon />
            </RadioItemInactiveIcon>
          )}
        </RadioItemDiv>
      </label>
    </RadioWrapper>
  );
};

const FlexContent = styled.div`
  display: flex;
  gap: 5px;
`;

const RadioItemDiv = styled.div`
  display: flex;
`;

const RadioItemActiveIcon = styled.div`
  & > svg {
    width: 40px;
    height: 40px;
  }
`;

const RadioItemInactiveIcon = styled.div`
  & > svg {
    width: 40px;
    height: 40px;
  }
`;

const RadioWrapper = styled.div`
  & > label {
    width: 100%;
    display: grid;

    & > * {
      grid-column: 1;
      grid-row: 1;
    }
  }

  & > label input[type='radio'] {
    visibility: hidden;
    position: absolute;
  }

  & > * {
    cursor: pointer;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  & > * {
  }
`;

const CustomFieldErrorInfo = styled(FieldErrorInfo)`
  margin-top: 12px;
  margin-left: 12px;

  &.slim-error {
    margin-top: 0px;
    margin-left: 0px;
  }
`;
